




































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';

import * as blockui from '@/helpers/block-ui';
import {
  CFMCoreEnumsEnumFteStatus,
  CFMDTOFteCategoryView,
  CFMDTOFteParameters,
  CFMDTOFteRoleView,
  CFMDTOFteSummaryView,
} from '@/scripts/services/ClientApiAuto';
import FteRoleDialog from './FteRoleDialog.vue';
import FteGuideDialog from './FteGuideDialog.vue';
import { toastApiError, toastResultError } from '@/helpers/apiToast';

/** Cfm.Core.Enums.EnumFteStatus; sunucudan sayi olarak gelir. */
const FteStatus = {
  Sufficient: 1 as CFMCoreEnumsEnumFteStatus,
  Marginal: 2 as CFMCoreEnumsEnumFteStatus,
  Insufficient: 3 as CFMCoreEnumsEnumFteStatus,
};

/** Hukum -> etiket, rozet ve grafik rengi. */
const STATUS_VIEW: Record<number, { label: string; badge: string; color: string }> = {
  [FteStatus.Sufficient]: { label: 'fte_status_sufficient', badge: 'm-badge--success', color: '#34bfa3' },
  [FteStatus.Marginal]: { label: 'fte_status_marginal', badge: 'm-badge--warning', color: '#ffb822' },
  [FteStatus.Insufficient]: { label: 'fte_status_insufficient', badge: 'm-badge--danger', color: '#f4516c' },
};

/** Intl.NumberFormat kurulumu pahali (ICU); dil x ondalik basina bir kez kurulur. */
const numberFormatters = new Map<string, Intl.NumberFormat>();

/** Metronic paleti; kategori sirasi sunucudan (buyukten kucuge) gelir, renk sirayla atanir. */
const CATEGORY_COLORS = ['#716aca', '#36a3f7', '#34bfa3', '#ffb822', '#9816f4', '#00c5dc', '#f4516c', '#c4c5d6'];
const INCIDENT_COLOR = '#575962';
const DEMAND_COLOR = '#f4516c';
const CAPACITY_COLOR = '#716aca';
const DATE_FORMAT = 'DD.MM.YYYY';

/** Bilgi popover'inin bir satiri: rol adi ve o rolun degeri (sayi ya da hukum rozeti). */
interface KpiDetail {
  label: string;
  value: string;
  badge?: { cls: string; text: string };
  negative?: boolean;
}

interface KpiTile {
  key: string;
  title: string;
  desc: string;
  value: string;
  badge: { cls: string; text: string } | null;
  colorClass: string;
  barClass: string;
  percent: number;
  change: string;
  number: string;
  details: KpiDetail[];
}

/**
 * FTE Hesaplama (dashboard altinda). Hesabin tamami sunucuda (GET /Fte/GetSummary); ekran
 * parametreleri gonderir, sonucu KPI kutulari, uc grafik ve adim adim tablolarla gosterir.
 * Hicbir sey saklanmaz: parametreler formda kalir, her "Hesapla" yeniden sorgular.
 */
@Component<FteCalculation>({
  components: {
    'fte-role-dialog': FteRoleDialog,
    'fte-guide-dialog': FteGuideDialog,
  },
})
export default class FteCalculation extends Vue {
  params: Required<CFMDTOFteParameters> = {
    Year: new Date().getFullYear(),
    WeeklyHours: 45,
    WeeksPerYear: 52,
    EfficiencyPercent: 100,
    MarginalThresholdPercent: 5,
  };

  summary: CFMDTOFteSummaryView | null = null;
  isLoading = false;

  /** Dialog yalnizca acikken DOM'da; kapaninca (close) kaldirilir, bir sonraki acilista rolleri yeniden okur. */
  isRoleDialogActive = false;

  /** Efor dagilimi grafiginin rolu; null = tesis geneli. */
  categoryChartRoleId: number | null = null;

  /** Reaktif DEGIL (bilincli olarak ilk degeri yok): Chart nesneleri Vue tarafindan gozlenmesin. */
  private charts!: any[];

  /** Efor dagilimi ayri tutulur: rol secimi yalnizca onu yeniden cizer. */
  private categoryChart!: any;

  created() {
    this.charts = [];
    this.categoryChart = null;
  }

  get categoryChartRole(): CFMDTOFteRoleView | null {
    return this.roles.find((r) => r.RoleId === this.categoryChartRoleId) || null;
  }

  get categoryChartTitle(): string {
    const role = this.categoryChartRole;
    return role ? this.translate('fte_chart_role_share', role.RoleName) : this.translate('fte_chart_category_share');
  }

  async mounted() {
    await this.load();
  }

  async openRoleDialog() {
    this.isRoleDialogActive = true;
    await this.$nextTick();
    (<FteRoleDialog>this.$refs.roleDialog).showDialog();
  }

  isGuideDialogActive = false;

  async openGuideDialog() {
    this.isGuideDialogActive = true;
    await this.$nextTick();
    (<FteGuideDialog>this.$refs.guideDialog).showDialog();
  }

  beforeDestroy() {
    this.destroyCharts();
  }

  // ------------------------------------------------------------ veri

  get locale(): string {
    return localStorage.getItem('vue-lang') === 'en-US' ? 'en-US' : 'tr-TR';
  }

  get roles(): CFMDTOFteRoleView[] {
    return (this.summary && this.summary.Roles) || [];
  }

  get categories(): CFMDTOFteCategoryView[] {
    return (this.summary && this.summary.Categories) || [];
  }

  get shiftTypes() {
    return (this.summary && this.summary.ShiftTypes) || [];
  }

  get totals() {
    return this.summary ? this.summary.Totals || null : null;
  }

  get notes() {
    return this.summary ? this.summary.Notes || null : null;
  }

  get withoutRole() {
    return this.summary ? this.summary.WithoutRole || null : null;
  }

  get hasData(): boolean {
    return this.roles.length > 0
      || this.shiftTypes.length > 0
      || !!(this.withoutRole && this.withoutRole.WorkCount);
  }

  /** Ham planli saat (rolsuz isler dahil) + olay; rol x kategori tablosunun toplam hucresi. */
  get rawDemandTotal(): number {
    const planned = this.categories.reduce((sum, c) => sum + (c.Hours || 0), 0);
    return planned + ((this.totals && this.totals.IncidentHours) || 0);
  }

  get actualsPeriodText(): string {
    if (!this.summary) return '';
    return this.translate('fte_actuals_period', [
      moment(this.summary.ActualsFromDate).format(DATE_FORMAT),
      moment(this.summary.ActualsEndDate).format(DATE_FORMAT),
    ]);
  }

  get grossHoursText(): string {
    return this.summary ? this.translate('fte_gross_hours_per_person', this.fmt(this.summary.GrossHoursPerPerson)) : '';
  }

  get deviationText(): string {
    if (!this.summary) return '';
    return this.translate('fte_planning_deviation', [
      this.fmt(this.summary.PlanningDeviationPercent, 1),
      (this.notes && this.notes.DeviationSampleCount) || 0,
    ]);
  }

  get kpiTiles(): KpiTile[] {
    const totals = this.totals;
    if (!totals) return [];
    const demand = totals.DemandHours || 0;
    const available = totals.AvailableHours || 0;
    const scale = Math.max(demand, available, 1);
    const status = this.statusView(totals.Status);
    const coverage = this.statusView(totals.CoverageStatus);
    const hours = this.translate('hour_short');
    const byRole = (value: (role: CFMDTOFteRoleView) => KpiDetail): KpiDetail[] => this.roles.map(value);
    return [
      {
        key: 'staff',
        title: this.translate('fte_staff_count'),
        desc: this.translate('fte_roles_in_scope', totals.RoleCount || 0),
        value: this.fmt(totals.StaffCount),
        badge: null,
        colorClass: 'm--font-brand',
        barClass: 'm--bg-brand',
        percent: 100,
        change: this.translate('fte_coverage_fte'),
        number: this.fmt(totals.CoverageRequiredFte, 2),
        details: byRole((r) => ({ label: r.RoleName, value: this.translate('fte_role_staff_count', r.StaffCount || 0) })),
      },
      {
        key: 'capacity',
        title: this.translate('fte_available_capacity'),
        desc: this.translate('fte_net_of_leave', this.fmt(totals.NetHours)),
        value: this.fmt(available),
        badge: null,
        colorClass: 'm--font-info',
        barClass: 'm--bg-info',
        percent: Math.round((available / scale) * 100),
        change: this.translate('fte_gross_hours'),
        number: this.fmt(totals.GrossHours),
        details: byRole((r) => ({ label: r.RoleName, value: `${this.fmt(r.AvailableHours)} ${hours}` })),
      },
      {
        key: 'demand',
        title: this.translate('fte_total_demand'),
        desc: this.translate('fte_planned_plus_incident', [this.fmt(totals.PlannedHoursWithDeviation), this.fmt(totals.IncidentHours)]),
        value: this.fmt(demand),
        badge: null,
        colorClass: 'm--font-danger',
        barClass: 'm--bg-danger',
        percent: Math.round((demand / scale) * 100),
        change: this.translate('fte_planned_hours'),
        number: this.fmt(totals.PlannedHours),
        details: byRole((r) => ({ label: r.RoleName, value: `${this.fmt(r.DemandHours)} ${hours}` })),
      },
      {
        key: 'surplus',
        title: this.translate('fte_surplus'),
        desc: this.translate('fte_capacity_normal'),
        value: this.fmt(totals.SurplusHours),
        badge: null,
        colorClass: (totals.SurplusHours || 0) < 0 ? 'm--font-danger' : 'm--font-success',
        barClass: (totals.SurplusHours || 0) < 0 ? 'm--bg-danger' : 'm--bg-success',
        percent: Math.min(100, Math.round((Math.abs(totals.SurplusHours || 0) / scale) * 100)),
        // Oran esigin altindaysa Sinirda: esik yaninda dursun ki hukum neden degismedi anlasilsin.
        change: `${this.translate('fte_surplus_percent')} · ${this.translate('fte_threshold_short')}`,
        number: `${this.pct(totals.SurplusPercent)} · ${this.pct(this.summary && this.summary.Parameters ? this.summary.Parameters.MarginalThresholdPercent : null)}`,
        details: byRole((r) => ({
          label: r.RoleName,
          value: `${this.fmt(r.SurplusHours)} ${hours}${r.SurplusPercent !== null && r.SurplusPercent !== undefined ? ` (${this.pct(r.SurplusPercent)})` : ''}`,
          negative: (r.SurplusHours || 0) < 0,
        })),
      },
      {
        key: 'status',
        title: this.translate('fte_overall_status'),
        // Hukum rollerin en kotusu: toplam fazla pozitifken de bir rol acikta olabilir.
        desc: this.roleStatusSummary(totals.InsufficientRoleCount, totals.MarginalRoleCount),
        value: '',
        badge: { cls: status.badge, text: this.translate(status.label) },
        colorClass: '',
        barClass: status.bar,
        percent: 100,
        // Alt satir: Tier IV sahada bulunma hukmu (kurali olan rollerin en kotusu).
        change: this.translate('fte_coverage_status'),
        number: totals.CoverageInsufficientRoleCount
          ? `${this.translate(coverage.label)} · ${this.translate('fte_roles_insufficient', totals.CoverageInsufficientRoleCount)}`
          : this.translate(coverage.label),
        details: byRole((r) => ({ label: r.RoleName, value: '', badge: { cls: this.statusBadge(r.Status), text: this.statusText(r.Status) } })),
      },
    ];
  }

  /** "2 rol yetersiz · 1 rol sinirda" ya da "tum roller yeterli". */
  roleStatusSummary(insufficient?: number, marginal?: number): string {
    const parts: string[] = [];
    if (insufficient) parts.push(this.translate('fte_roles_insufficient', insufficient));
    if (marginal) parts.push(this.translate('fte_roles_marginal', marginal));
    return parts.length ? parts.join(' · ') : this.translate('fte_roles_all_sufficient');
  }

  // ------------------------------------------------------------ yukleme

  async load() {
    this.isLoading = true;
    blockui.pageBlock(this);
    try {
      const response = await this.$globalApiClient.fte.fteGetSummary({ ...this.params });
      if (!response.data.IsSuccess) {
        toastResultError(response.data);
        return;
      }
      this.summary = response.data.Data || null;
      await this.$nextTick();
      this.renderCharts();
    } catch (e) {
      toastApiError(e);
    } finally {
      blockui.unBlockPage();
      this.isLoading = false;
    }
  }

  // ------------------------------------------------------------ grafikler

  renderCharts() {
    this.destroyCharts();
    if (!this.summary || !this.hasData) return;

    const roles = this.roles;
    const labels = roles.map((r) => r.RoleName);

    this.charts.push(this.makeChart('demandChart', {
      type: 'bar',
      data: {
        labels,
        // Mesai dahil kapasite grafikte YOK (kullanici karari): normal kapasiteden cogu rolde ayirt
        // edilemiyordu ve ucuncu cubuk okumayi zorlastiriyordu; degeri rol tablosunda duruyor.
        datasets: [
          { label: this.translate('fte_demand'), backgroundColor: DEMAND_COLOR, data: roles.map((r) => r.DemandHours || 0) },
          { label: this.translate('fte_capacity_normal'), backgroundColor: CAPACITY_COLOR, data: roles.map((r) => r.AvailableHours || 0) },
        ],
      },
      options: this.barOptions(false),
    }));

    this.renderCategoryChart();

    this.charts.push(this.makeChart('roleCategoryChart', {
      type: 'bar',
      data: {
        labels,
        datasets: [
          ...this.categories.map((category, i) => ({
            label: category.CategoryName,
            backgroundColor: CATEGORY_COLORS[i % CATEGORY_COLORS.length],
            data: roles.map((r) => this.hoursOf(r.Categories, category.CategoryId)),
          })),
          { label: this.translate('incident'), backgroundColor: INCIDENT_COLOR, data: roles.map((r) => r.IncidentHours || 0) },
        ],
      },
      options: this.barOptions(true),
    }));
  }

  /** Rol bazli cubuk grafiklerin ortak secenekleri; yigin yalnizca kategori kiriliminda. */
  private barOptions(stacked: boolean) {
    return {
      maintainAspectRatio: false,
      legend: { position: 'bottom' },
      scales: {
        // autoSkip kapali: Chart.js dar alanda her ikinci rol adini gizliyor, cubuk yanlis role okunuyordu.
        xAxes: [{ stacked, ticks: { autoSkip: false } }],
        yAxes: [{ stacked, ticks: { beginAtZero: true, callback: this.hoursLabel } }],
      },
      tooltips: {
        callbacks: {
          label: (item: any, data: any) => `${data.datasets[item.datasetIndex].label}: ${this.hoursLabel(item.yLabel)}`,
        },
      },
    };
  }

  /** Eksen ve tooltip degeri; Chart.js sayiyi bazen metin verir. */
  private hoursLabel = (value: any): string => this.fmt(Number(value));

  /**
   * Efor dagilimi (doughnut). Kategori renkleri tesis listesindeki siraya baglidir ki rol
   * degistirince ayni kategori ayni renkte kalsin; secili rolde saati olmayan kategori cizilmez.
   */
  renderCategoryChart() {
    if (this.categoryChart) {
      this.categoryChart.destroy();
      this.categoryChart = null;
    }
    if (!this.summary || !this.hasData) return;

    const role = this.categoryChartRole;
    const slices = this.categories
      .map((category, i) => ({
        label: category.CategoryName,
        color: CATEGORY_COLORS[i % CATEGORY_COLORS.length],
        hours: role ? this.hoursOf(role.Categories, category.CategoryId) : category.Hours || 0,
      }))
      .filter((s) => s.hours > 0);
    const incidentHours = role ? role.IncidentHours || 0 : (this.totals && this.totals.IncidentHours) || 0;
    if (incidentHours > 0) {
      slices.push({ label: this.translate('incident'), color: INCIDENT_COLOR, hours: incidentHours });
    }
    const total = slices.reduce((sum, s) => sum + s.hours, 0);

    this.categoryChart = this.makeChart('categoryChart', {
      type: 'doughnut',
      data: {
        labels: slices.map((s) => s.label),
        datasets: [{ data: slices.map((s) => s.hours), backgroundColor: slices.map((s) => s.color) }],
      },
      options: {
        maintainAspectRatio: false,
        legend: { position: 'right' },
        tooltips: {
          callbacks: {
            label: (item: any, data: any) => {
              const value = data.datasets[0].data[item.index];
              const share = total > 0 ? Math.round((value / total) * 1000) / 10 : 0;
              return `${data.labels[item.index]}: ${this.hoursLabel(value)} (${this.fmt(share, 1)}%)`;
            },
          },
        },
      },
    });
  }

  private makeChart(ref: string, config: any) {
    const canvas = this.$refs[ref] as HTMLCanvasElement | undefined;
    if (!canvas) return null;
    return new Chart(canvas, config);
  }

  private destroyCharts() {
    this.charts.forEach((chart) => chart && chart.destroy());
    this.charts = [];
    if (this.categoryChart) {
      this.categoryChart.destroy();
      this.categoryChart = null;
    }
  }

  // ------------------------------------------------------------ yardimcilar

  /** Kategori listesinde (rolun ya da rolsuz islerin) verilen kategorinin saati; yoksa 0. */
  hoursOf(categories: CFMDTOFteCategoryView[] | null | undefined, categoryId?: number): number {
    const match = (categories || []).find((c) => c.CategoryId === categoryId);
    return match ? match.Hours || 0 : 0;
  }

  leaveBreakdown(role: CFMDTOFteRoleView): string {
    return this.translate('fte_leave_breakdown', [this.fmt(role.AnnualLeaveHours), this.fmt(role.SickLeaveHours), this.fmt(role.OtherLeaveHours)]);
  }

  /** Binlik ayirici diline gore; null "olculmedi" demek, tire ile gosterilir. */
  fmt(value?: number | null, digits = 0): string {
    if (value === null || value === undefined || Number.isNaN(value)) return '–';
    const key = `${this.locale}|${digits}`;
    let formatter = numberFormatters.get(key);
    if (!formatter) {
      formatter = new Intl.NumberFormat(this.locale, { minimumFractionDigits: digits, maximumFractionDigits: digits });
      numberFormatters.set(key, formatter);
    }
    return formatter.format(value);
  }

  pct(value?: number | null): string {
    if (value === null || value === undefined) return '–';
    const text = this.fmt(value, 1);
    return this.locale === 'tr-TR' ? `%${text}` : `${text}%`;
  }

  statusView(status?: CFMCoreEnumsEnumFteStatus | null) {
    const view = status ? STATUS_VIEW[status] : null;
    return view
      ? { label: view.label, badge: view.badge, bar: view.badge.replace('m-badge--', 'm--bg-') }
      : { label: 'fte_status_not_measured', badge: 'm-badge--metal', bar: 'm--bg-metal' };
  }

  statusText(status?: CFMCoreEnumsEnumFteStatus | null): string {
    return this.translate(this.statusView(status).label);
  }

  statusBadge(status?: CFMCoreEnumsEnumFteStatus | null): string {
    return this.statusView(status).badge;
  }

  rowClass(status?: CFMCoreEnumsEnumFteStatus | null): string {
    if (status === FteStatus.Insufficient) return 'fte-row--insufficient';
    return status === FteStatus.Marginal ? 'fte-row--marginal' : '';
  }

  signClass(value?: number | null): string {
    return (value || 0) < 0 ? 'm--font-danger' : '';
  }
}
